import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { INavigationResponse } from '@ncg/data';
import { FeatureDetectionService } from '../core/feature-detection.service';
import { breakpointQueries } from '../utils/helpers/breakpoints';

@Component({
    selector: 'ncg-footer-nav',
    template: `
        <div [ngClass]="containerClass ?? 'container'">
            <div class="footer-top__columns columns is-desktop">
                <ncg-expansion-panel
                    class="footer-top__column column"
                    [forceStatic]="forceStaticFooterAccordion"
                    [ngClass]="{ 'footer-top__column--empty': !menu.children?.length }"
                    *ngFor="let menu of items | filter: 'includeInFooter'; trackBy: trackByMethod">
                    <h4 expansion-title class="footer-top__menu-label">
                        <ncg-link
                            *ngIf="(menu.pageLink?.url || menu.url) && forceStaticFooterAccordion; else accordionTitle"
                            [link]="menu.pageLink ?? { name: menu.name, isExternal: false, url: menu.url }"
                            [stopPropagation]="true">
                            {{ menu.name }}
                        </ncg-link>
                        <ng-template #accordionTitle>{{ menu.name }}</ng-template>
                    </h4>

                    <ng-container *ngIf="menu.children?.length" expansion-icon>
                        <svg-icon-sprite src="chevron-light-down" [width]="'30px'" [height]="'30px'" aria-hidden="true"></svg-icon-sprite>
                    </ng-container>

                    <ul class="footer-top__menu-list menu-list" *ngIf="menu.children?.length">
                        <li
                            class="expansion-panel__stagger--animate"
                            *ngFor="let item of menu.children | filter: 'includeInFooter'; trackBy: trackByMethod">
                            <ncg-link [link]="item.pageLink ?? { name: item.name, isExternal: false, url: item.url }">{{ item.name }}</ncg-link>
                        </li>
                    </ul>
                </ncg-expansion-panel>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FooterNavComponent implements OnInit, OnDestroy {
    private readonly _forceStaticHandler = this.setForceStatic.bind(this);
    public forceStaticFooterAccordion = false;
    @Input() public items: INavigationResponse[];
    @Input() public containerClass?: string;

    constructor(
        private readonly features: FeatureDetectionService,
        private readonly cd: ChangeDetectorRef
    ) {}

    public ngOnInit(): void {
        if (!this.features.isBrowser()) {
            return;
        }
        // Because the footer goes from accordion on mobile, to just showing everything on desktop, this is needed.
        this._forceStaticHandler(window.matchMedia(breakpointQueries.desktop));
        window.matchMedia(breakpointQueries.desktop).addEventListener('change', this._forceStaticHandler);
    }

    public ngOnDestroy(): void {
        if (!this.features.isBrowser()) {
            return;
        }
        window.matchMedia(breakpointQueries.desktop).removeEventListener('change', this._forceStaticHandler);
    }

    public trackByMethod(index: number, item: any) {
        return item.id || index;
    }

    private setForceStatic(query: MediaQueryList | MediaQueryListEvent): void {
        this.forceStaticFooterAccordion = query.matches;
        this.cd.markForCheck();
    }
}
